import React from 'react';
import { Expense } from '../../../types/expenseTypes';
import { Pencil, Trash } from 'lucide-react';
import { shortEmail } from '../../../utils/shortEmail';

interface ExpenseCardProps {
  row: Expense;
  onEdit?: (row: Expense) => void;
  onDelete?: (row: Expense) => void;
}

const statusColors: Record<string, string> = {
  approved: 'bg-success-500 text-white',
  pending: 'bg-warning-500 text-white',
  rejected: 'bg-error-500 text-white',
};

const ExpenseCard: React.FC<ExpenseCardProps> = ({ row, onEdit, onDelete }) => {
  const statusColor = statusColors[row.approvalStatus || 'pending'] || 'bg-gray-500 text-white';
  return (
    <div className="rounded-xl shadow bg-white text-sm gap-2 mb-3 px-4 py-3 flex flex-col">
      <div className="flex justify-between items-start">
        <h4 className="font-medium text-base">{row.shop}</h4>
        <span className={`rounded-full px-2 py-0.5 text-xs ${statusColor}`}>{row.approvalStatus}</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="font-semibold">₹{Number(row.amount).toLocaleString('en-IN')}</div>
        <div className="flex gap-1">
          {onEdit && (
            <button
              onClick={() => onEdit(row)}
              className="p-1 rounded hover:bg-gray-100"
              aria-label="Edit"
              title="Edit"
              type="button"
            >
              <Pencil size={16} />
            </button>
          )}
          {onDelete && (
            <button
              onClick={() => onDelete(row)}
              className="p-1 rounded hover:bg-gray-100 text-error-600"
              aria-label="Delete"
              title="Delete"
              type="button"
            >
              <Trash size={16} />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-wrap gap-2 text-muted-foreground">
        <span>{row.costCenter}</span>
        <span>{row.category}</span>
        {row.createdBy && <span className="ml-auto">{shortEmail(row.createdBy)}</span>}
      </div>
    </div>
  );
};

export default ExpenseCard;
